import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../shared/services/core/api.service';
import { ScorecardsV2Response } from './models/scorecard-v2.model';

/** Version 2
 *
 * Unlike V1, these methods do not write to the store.
 * Data is returned as plain Observables, keeping state management
 * out of the service. Use ScorecardFacade to fetch and populate the store.
 */
@Injectable({ providedIn: 'root' })
export class ScorecardV2Service {
  private readonly api = inject(ApiService);

  /**
   * Fetches the customer's scorecards together with all of their badges in a single call.
   * The LCID is resolved by the API from the authenticated customer, so it is not passed here.
   */
  fetchScorecards(): Observable<ScorecardsV2Response> {
    return this.api.getAnySingle<ScorecardsV2Response>('scorecard/v2');
  }
}
